import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { HttpClient } from '@angular/common/http';
import { PlanModel } from '../models/plan.model';
import { SignUpSignatureModel } from '../models/signUpSignature.model';
import { PromiseState } from 'q';
import { environment } from '../../environments/environment';
import { ImageModel } from '../models/image.model';

@Injectable()
export class PlanService extends AppService<PlanModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async getAll(): Promise<Array<PlanModel>> {
    return await this.getAllAsync(`Assinatura/PlanosDisponiveis`)
      .then((_plans: Array<PlanModel>) => {
        _plans.forEach(plan => {
          this.setUrlImageToPlan(plan);
        });

        return _plans;
      });
  }

  private setUrlImageToPlan(plan: PlanModel) {
    plan.Image = new ImageModel();
    plan.Image.url = `${environment.customBlobUrl}/${plan.EstabelecimentoId}/${plan.Id}.jpg?v=${new Date().getTime()}`;
  }

  async getDetail(planId: string): Promise<any> {
    const result = await this.getAllAsync(`Plano/${planId}`);
    return result;
  }

  async signUp(signInSignature: SignUpSignatureModel) {
    const result = await this.postAsync(`Assinatura`, signInSignature);
    return result;
  }

  async cancel(signatureId: string) {
    const result = await this.postAsync(`Assinatura/${signatureId}/Cancelar`);
    return result;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/plan.service.ts